export class RelatorioModel {
  TipoRelatorio: any;
  Entidade: any;
}



// WEBPACK FOOTER //
// ./src/app/shared/model/relatorio.model.ts